import { useEffect } from 'react';
import { useToast } from '@/contexts/ToastContext';
import { APP_VERSION } from '@/lib/appVersion';

/** Версия, на которой человек был в прошлый раз. */
export const LAST_VERSION_KEY = 'tracker:last-version';

/**
 * Тост после перезагрузки на новую версию — по кнопке или принудительной: без него принудительная
 * перезагрузка выглядит как сбой. При первом входе сравнивать не с чем, тоста нет.
 */
export function useUpdatedToast() {
  const { showSuccess } = useToast();
  useEffect(() => {
    let last: string | null;
    try {
      last = localStorage.getItem(LAST_VERSION_KEY);
      localStorage.setItem(LAST_VERSION_KEY, APP_VERSION);
    } catch {
      return;
    }
    if (last && last !== APP_VERSION) showSuccess(`Трекер обновлён до версии ${APP_VERSION}`);
  }, [showSuccess]);
}
